import { actionUrl } from "@/apiClient";

const reportingUrl = (import.meta.env.VUE_APP_REPORTING_URL || "").replace(/\/$/g, "") + "/";
const workflowsUrl = (import.meta.env.VUE_APP_WORKFLOWS_URL || "").replace(/\/$/g, "") + "/";
const StudioCmsUrl =  (import.meta.env.VUE_APP_STUDIO_CMS_URL || "").replace(/\/$/g, "");

// ! INSTRUCTIONS REGARDING `MODULES.*.PERMISSION`
// - the string has to match any string present in the slugs column of the permissions table in DB

export const modules = [
    {
        name: "Dashboard",
        slug: "dashboard",
        path: "/dashboard",
        description: "All your data at a glance, customized for you",
        image: new URL(`../assets/Dashboard-icon.svg`, import.meta.url).href,
        SelectedImage: new URL(`../assets/Dashboard-icon-selected.svg`, import.meta.url).href,
        enable: true,
        page: true,
        permission: "Dashboard",
    },
    {
        name: "Customers",
        slug: "customers",
        path: "/customers",
        description: "Know your customers deeper in 360-degree & preferences",
        image: new URL(`../assets/Customers-icon.svg`, import.meta.url).href,
        SelectedImage: new URL(`../assets/Customers-icon-selected.svg`, import.meta.url).href,
        enable: true,
        page: true,
        permission: "Customers",
    },
    {
        name: "Loyalty",
        slug: "loyalty",
        path: "/loyalty",
        description: "Build true Loyalty with emotional and contextual rewards",
        image: new URL(`../assets/Loyalty-icon.svg`, import.meta.url).href,
        SelectedImage: new URL(`../assets/Loyalty-icon-selected.svg`, import.meta.url).href,
        enable: true,
        page: true,
        permission: "Loyalty",
    },
    {
        name: "Experience",
        slug: "experience",
        path: "/experience",
        description: "Track and enhance customer experience in real time",
        image: new URL(`../assets/Experience-icon.svg`, import.meta.url).href,
        SelectedImage: new URL(`../assets/Experience-icon-selected.svg`, import.meta.url).href,
        enable: true,
        page: true,
        permission: "Experience",
    },
    {
        name: "Engagement",
        slug: "engagement",
        path: "/engagement",
        description: "Drive Personalized Campaigns that keeps customers engaged",
        image: new URL(`../assets/Engagement-icon.svg`, import.meta.url).href,
        SelectedImage: new URL(`../assets/Engagement-icon-selected.svg`, import.meta.url).href,
        enable: true,
        page: true,
        permission: "Engagement",
    },
   
    {
        name: "Offer Engine",
        slug: "offers",
        path: "/offers",
        description: "Create and manage dynamic offers to get customers hooked",
        image: new URL("../assets/Offers-icon.svg", import.meta.url).href,
        SelectedImage: new URL(`../assets/Offers-icon-selected.svg`, import.meta.url).href,
        enable: true,
        page: true,
        permission: 'Offers',
    },
    {
        name: "Alerts",
        slug: "alerts",
        path: "/alerts",
        description: "Manage all your communications unified at one place for any channel",
        image: new URL("../assets/Alerts-icon.svg", import.meta.url).href,
        SelectedImage: new URL(`../assets/Alerts-icon-selected.svg`, import.meta.url).href,
        enable: true,
        page: true,
        permission: "Alerts",
    },
    {
        name: "Workflows",
        slug: "workflows",
        path: workflowsUrl,
        description: "Build dynamic customer journeys and automate your data flows",
        image: new URL("../assets/Workflows-icon.png", import.meta.url).href,
        SelectedImage: new URL(`../assets/Workflows-icon.png`, import.meta.url).href,
        enable: true,
        page: false,
        permission: 'Workflows',
    },
    {
        name: "Seamless",
        slug: "seamless",
        path: "/seamless",
        description: "Manage your online orders, users and transactions",
        image: new URL("../assets/Seamless-icon.svg", import.meta.url).href,
        SelectedImage: new URL(`../assets/Seamless-icon-selected.svg`, import.meta.url).href,
        enable: true,
        page: true,
        permission: "Seamless",
    },
    {
        name: "Content Management",
        slug: "cms",
        path: (permission, brand) => permission('Cms.Studio') && !permission('Cms.Headless') ? `${StudioCmsUrl}?brand=${brand?.uri}` : `/${brand?.uri}/cms`,
        description: "Manage content of your microsites & SDKs",
        image: new URL("../assets/Cms-icon.svg", import.meta.url).href,
        SelectedImage: new URL(`../assets/Cms-icon-selected.svg`, import.meta.url).href,
        enable: true,
        page: true,
        permission: "Cms",
    },
    {
        name: "Referral",
        slug: "referral",
        path: "/referral",
        description: "Turn your customers to brand advocates & acquire new customers",
        image: new URL("../assets/Referral-icon.svg", import.meta.url).href,
        SelectedImage: new URL(`../assets/Referral-icon.svg`, import.meta.url).href,
        enable: true,
        page: true,
        permission: 'Referral',
    },
    {
        name: "Gifting",
        slug: "gifting",
        path: "/gifting",
        description: "Create & Manage your own branded gift cards",
        image: new URL("../assets/Gifting-icon.svg", import.meta.url).href,
        SelectedImage: new URL(`../assets/Gifting-icon-selected.svg`, import.meta.url).href,
        enable: true,
        page: true,
        permission: 'Gifting',
    },
    {
        name: "Catalog",
        slug: "catalogue",
        path: "/catalogue",
        description: "Missing anything from our old experience? Check here",
        image: new URL("../assets/Seamless-icon.svg", import.meta.url).href,
        SelectedImage: new URL(`../assets/Seamless-icon-selected.svg`, import.meta.url).href,
        enable: true,
        page: true,
        permission: "Configurations.Catalogue",
    },
    {
        name: "Phygital & Url",
        slug: "phygital",
        path: "/phygital",
        description: "Create & manage dynamic links & QR Codes",
        image: new URL("../assets/Referral-icon.svg", import.meta.url).href,
        SelectedImage: new URL(`../assets/Referral-icon.svg`, import.meta.url).href,
        enable: true,
        page: true,
        permission: ["Phygital", "UrlShortener"],
    },
    // {
    //     name: "Url Shortener",
    //     slug: "url-shortener",
    //     path: "/url-shortener",
    //     description: "Turn your ordinary links to a more powerful tool",
    //     image: new URL("../assets/Referral-icon.svg", import.meta.url).href,
    //     SelectedImage: new URL(`../assets/Referral-icon.svg`, import.meta.url).href,
    //     enable: true,
    //     page: true,
    //     permission: 'UrlShortener',
    // },
    // {
    //     name: "Analytics",
    //     slug: "analytics",
    //     path: reportingUrl,
    //     description: "Customized reporting & Analytics for all your data",
    //     image: new URL("../assets/Analytics-icon.png", import.meta.url).href,
    //     SelectedImage: new URL(`../assets/Analytics-icon.png`, import.meta.url).href,
    //     enable: true,
    //     page: false,
    //     permission: 'Analytics',
    // },
    
    {
        name: "Imports",
        slug: "imports",
        path: "/imports",
        description: "Bulk Import customers, transactions or other data.",
        image: new URL("../assets/Imports-icon.svg", import.meta.url).href,
        SelectedImage: new URL("../assets/Imports-icon-selected.svg", import.meta.url).href,
        enable: true,
        page: true,
        permission: "Imports",
    },
    {
        name: "User Management",
        slug: "user-management",
        path: "/user-management",
        description: "Manage users, roles and permissions",
        image: new URL("../assets/UserManagement-icon.svg", import.meta.url).href,
        SelectedImage: new URL("../assets/UserManagement-icon-selected.svg", import.meta.url).href,
        enable: true,
        page: true,
        permission: "UserManagement",
    },
    {
        name: "Billing",
        slug: "billing",
        path: "/billing",
        description: "Manage your billing and subscriptions",
        image: new URL("../assets/Billing-icon.png", import.meta.url).href,
        SelectedImage: new URL("../assets/Billing-icon-selected.png", import.meta.url).href,
        enable: true,
        page: true,
        permission: "Billing",
    },
    {
        name: "Configurations",
        slug: "configuration",
        path: actionUrl + "business/merchants",
        description: "All your administrative configurations",
        image: new URL("../assets/Configuration-icon.svg", import.meta.url).href,
        SelectedImage: new URL(`../assets/Configuration-icon-selected.svg`, import.meta.url).href,
        enable: true,
        page: false,
        permission: "Configurations",
    },
    {
        name: "Content Library",
        slug: "contentLibrary",
        path: actionUrl + "business/websites",
        description: "Manage content of your microsites & SDKs",
        image: new URL("../assets/Cms-icon.svg", import.meta.url).href,
        SelectedImage: new URL(`../assets/Cms-icon-selected.svg`, import.meta.url).href,
        enable: true,
        page: false,
        permission: "ContentManagement.V1",
    },
    
    {
        name: "Wallet",
        slug: "wallet",
        path: "/wallet",
        description: "Manage your closed loop wallet",
        image: new URL("../assets/Wallet-icon.png", import.meta.url).href,
        SelectedImage: new URL(`../assets/Wallet-icon.png`, import.meta.url).href,
        enable: true,
        page: true,
        permission: "Wallet",
    },
    
    // {
    //     name: "Stride",
    //     slug: "stride",
    //     path: "/stride",
    //     description: "Manage your own last mile delivery fleet",
    //     image: new URL("../assets/Stride-icon.svg", import.meta.url).href,
    //     SelectedImage: new URL(`../assets/Stride-icon-selected.svg`, import.meta.url).href,
    //     enable: true,
    //     page: true,
    //     permission: 'Stride',
    // },
    {
        name: "Integrations",
        slug: "integrations",
        path: "/integrations",
        description: "Integrations",
        image: new URL("../assets/Integration-icon.png", import.meta.url).href,
        SelectedImage: new URL(`../assets/Integration-icon-selected.png`, import.meta.url).href,
        enable: true,
        page: true,
        permission: "Integrations",
    },
     
    // {
    //     name: "Cogent POS",
    //     slug: "pos",
    //     path: actionUrl + "pos",
    //     description: "The nextgen POS system for your business",
    //     image: new URL("../assets/pos.png", import.meta.url).href,
    //     SelectedImage: new URL(`../assets/pos.png`, import.meta.url).href,
    //     enable: true,
    //     page: false,
    //     permission: 'Cogent',
    // },
    {
        name: "Old Dashboard",
        slug: "oldDashboard",
        path: actionUrl + "business/dashboard",
        description: "Missing anything from our old experience? Check here",
        image: new URL("../assets/old-dashboard.svg", import.meta.url).href,
        SelectedImage: new URL(`../assets/old-dashboard-selected.svg`, import.meta.url).href,
        enable: true,
        page: false,
        permission: "OldDashboard",
    },
    {
        name: "Cashier",
        slug: "cashier",
        path: "/cashier",
        description: "Missing anything from our old experience? Check here",
        image: new URL("../assets/Seamless-icon.svg", import.meta.url).href,
        SelectedImage: new URL(`../assets/Seamless-icon-selected.svg`, import.meta.url).href,
        enable: true,
        page: true,
        permission: "Cashier",
    },
   
];
